import { NextCustomImage } from 'components/Image';
import Link from 'components/Globals/Base/Link';
import type { FranchiseListItemPreview } from 'interfaces/content/Ranking';
import type { EventData } from 'services/Gtm/entities';
import { FranchiseItemTitle, RakingItemInnerWrapper, RankingItemWrapper, Rank } from './RankingItemStyles';

export interface RankingItemProps {
  franchiseItem: FranchiseListItemPreview;
  trackingData: EventData;
  showOrder: boolean;
}

const RankingItem: React.FC<RankingItemProps> = ({ franchiseItem, trackingData, showOrder }: RankingItemProps) => {
  const { title, image, slug } = franchiseItem;
  const missingImageClass = image ? '' : 'no-image';
  return (
    <RankingItemWrapper>
      <Link
        href={slug}
        trackingData={trackingData}
        className={missingImageClass}
      >
        {showOrder && <Rank className='no-hover'> {franchiseItem.rank} </Rank>}
        {image && (
          <NextCustomImage
            src={image}
            alt={title}
            width={184}
            height={123}
          />
        )}
        <RakingItemInnerWrapper className={missingImageClass}>
          <FranchiseItemTitle>{title}</FranchiseItemTitle>
        </RakingItemInnerWrapper>
      </Link>
    </RankingItemWrapper>
  );
};

export default RankingItem;
